import { motion } from 'motion/react';

import type { Strength } from '@smartapply/shared';

import { MarginNote } from './MarginNote.js';

interface StrengthsListProps {
  strengths: Strength[];
}

export function StrengthsList({ strengths }: StrengthsListProps) {
  if (strengths.length === 0) return null;

  return (
    <ul className="space-y-0">
      {strengths.map((s, i) => (
        <motion.li
          key={s.id}
          initial={{ opacity: 0, y: 6 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.25, delay: Math.min(i * 0.04, 0.4), ease: 'easeOut' }}
          className="card-paper relative mb-4 grid gap-6 overflow-hidden rounded-sm py-6 pl-7 pr-6 lg:grid-cols-[1fr_280px] lg:gap-12"
          style={{ borderLeft: '3px solid var(--accent-forest)' }}
        >
          <div
            aria-hidden
            className="absolute inset-x-0 top-0 h-1"
            style={{ backgroundColor: 'var(--accent-forest-bg)' }}
          />
          <div>
            <header className="flex items-baseline gap-3">
              <span
                className="inline-flex items-center rounded-sm px-1.5 py-0.5 font-mono text-[11px] font-semibold uppercase tracking-wider tabular-nums"
                style={{
                  color: 'var(--accent-forest)',
                  backgroundColor: 'var(--accent-forest-bg)',
                  border: '1px solid rgba(47, 90, 64, 0.2)',
                }}
              >
                S.{(i + 1).toString().padStart(2, '0')}
              </span>
              <h3 className="font-serif text-lg font-medium leading-snug text-[var(--ink-primary)]">
                {s.title}
              </h3>
            </header>
            <p className="mt-3 font-sans text-sm leading-relaxed text-[var(--ink-secondary)]">
              {s.evidence}
            </p>
          </div>
          <aside className="lg:pt-1">
            <MarginNote severity="positive" label="por que importa">
              {s.whyItMatters}
            </MarginNote>
          </aside>
        </motion.li>
      ))}
    </ul>
  );
}
